import { TagComponent, Component, Types } from "ecsy";

export class Object3DCmp extends Component {}
Object3DCmp.schema = {
  object: { type: Types.Ref },
};

/**
 * VR中射线击中挂载有这个组件的物体时让cursor跟随射线，针对UI对象
 */
export class UIIntersectableCmp extends TagComponent {}

/**
 * VR中射线击中挂载有这个组件的物体时让cursor跟随射线，针对非UI对象
 */
export class ObjectIntersectableCmp extends TagComponent {}
